module.exports = __webpack_public_path__ + "static/media/16.9e35888b.png";